import api from "../../../config/api";
import { myTripsDataRequest, getMyTripsDataSuccess, getMyTripDataFailure, postAddTripPending, postAddTripSuccess, postAddTripFailure, myTripsPnrRequest, getPnrDataSuccess, getPnrDataFailure, getPnrDataFailure1, myTripsCheckinRequest, postCheckInDataSuccess, postCheckInDataFailure, retrieveTripsRequest, retrieveTripsRequestSuccess, retrieveTripsRequestFailure, myTripsDataRequestClaim } from "../slice/myTripsSlice";
import { put, takeLatest, call } from "redux-saga/effects";
import { config } from "../../../config/global";
import { getTripsDataFailure, getTripsDataSuccess, tripsDataRequest } from "../slice/allTripsSlice";
const fetchUpcomingTripData = async myTripsPayload => {
  const FETCH_API_URL = config.TEAMSITE_MY_TRIPS_UPCOMING_TRIPS_API;
  let myTripsPayloadData = {
    category: myTripsPayload.category
  };
  const data = {
    mode: "no-cors",
    headers: {
      "App-Authorization": localStorage.getItem("accesstoken") || "",
      "Content-Type": "application/json"
    },
    loader: myTripsPayload?.pathName?.includes("my-trips") ? true : false,
    isGenericErr: true
  };
  const response = await api.get(`${FETCH_API_URL}?category=${myTripsPayloadData.category}`, data);
  return response;
};
const fetchPnrData = async retrievePnrPayload => {
  const RETRIVE_PNR_API_URL = config.MY_TRIPS_RETRIEVE_API;
  let retrievePnrPayloadData = {
    isUpcoming: retrievePnrPayload.isUpcoming
  };
  const data = {
    mode: "no-cors",
    headers: {
      "App-Authorization": localStorage.getItem("accesstoken") || "",
      "Content-Type": "application/json"
    },
    loader: true
  };
  let pnrPayload = {
    pnr: retrievePnrPayload.pnr,
    lastName: retrievePnrPayload.lastName,
    pastTrip: retrievePnrPayload?.pastTrip,
    ticketNumber: retrievePnrPayload?.ticketNumber
  };
  const response = await api.post(`${RETRIVE_PNR_API_URL}?isUpcoming=${retrievePnrPayloadData.isUpcoming}`, pnrPayload, data);
  return response;
};
const updateHeaderData = async payload => {
  const RETRIVE_PNR_API_URL = config.TEAMSITE_RETRIEVE_PNR_API;
  let headerData = {
    headers: {
      "App-Authorization": localStorage.getItem("accesstoken") || "",
      "Content-Type": "application/json"
    }
  };
  let pnrPayload = {
    pnr: payload.pnr,
    lastName: payload.lastName,
    pastTrip: payload.pastTrip
  };
  const response = await api.post(RETRIVE_PNR_API_URL, pnrPayload, headerData);
  return response;
};
const fetchCheckInData = async (payload, isArray) => {
  const RETRIVE_CHECKIN_API_URL = config.MY_TRIPS_CHECK_IN_CPR_API;
  const data = {
    mode: "no-cors",
    headers: {
      "App-Authorization": localStorage.getItem("accesstoken") || "",
      "Content-Type": "application/json"
    },
    loader: true
  };
  if (!isArray) {
    let checkInStatusPayload = {
      tokenRequired: true,
      closeSession: true,
      checkIn: {
        companyId: "TG",
        pnr: payload.pnr
      }
    };
    const response = await api.post(RETRIVE_CHECKIN_API_URL, checkInStatusPayload, data);
    return response;
  } else {
    const result = [];
    for (const param of payload) {
      let checkInStatusPayload = {
        tokenRequired: true,
        closeSession: true,
        checkIn: {
          companyId: "TG",
          pnr: param.pnr
        }
      };
      const response = await api.post(RETRIVE_CHECKIN_API_URL, checkInStatusPayload, data);
      result.push(response.data);
    }
    return result;
  }
};
function* getCheckinData(action) {
  try {
    const {
      payload
    } = action;
    if (Array.isArray(payload)) {
      const response = yield call(fetchCheckInData, payload, Array.isArray(payload));
      yield put(postCheckInDataSuccess(response));
    } else {
      const response = yield call(fetchCheckInData, payload, false);
      yield put(postCheckInDataSuccess(response.data));
    }
  } catch (error) {
    yield put(postCheckInDataFailure(error.message));
  }
}
function* getPnrData(action) {
  const {
    payload
  } = action;
  try {
    const response = yield call(fetchPnrData, payload);
    yield put(getPnrDataSuccess(response.data));
  } catch (error) {
    yield put(getPnrDataFailure(error.message));
    yield put(getPnrDataFailure1(error.response.data));
  }
}
function* getUpcomingTripsData(action) {
  const {
    payload
  } = action;
  try {
    const response = yield call(fetchUpcomingTripData, payload);
    let modifiedResponse = {
      ...response.data,
      pnrDetails: response.data.pnrDetails.map((pnrDetail, index) => {
        if (index > 2) {
          return {
            ...pnrDetail,
            flightDetails: []
          };
        }
        return pnrDetail;
      })
    };
    yield put(getMyTripsDataSuccess(modifiedResponse));
  } catch (error) {
    yield put(getMyTripDataFailure(error.message));
  }
}
const fetchAddTripData = async myTripsPayload => {
  const ADD_TRIP_API_URL = config.ADD_MY_TRIP_API;
  let data = {
    mode: "no-cors",
    headers: {
      "App-Authorization": localStorage.getItem("accesstoken") || "",
      "Content-Type": "application/json"
    },
    loader: true
  };
  const response = await api.post(ADD_TRIP_API_URL, myTripsPayload, data);
  return response;
};
function* postAddTripsData(action) {
  const {
    payload
  } = action;
  try {
    const response = yield call(fetchAddTripData, payload);
    yield put(postAddTripSuccess(response.data));
  } catch (error) {
    yield put(postAddTripFailure(error));
  }
}
function* retrieveTripDetails(action) {
  try {
    const {
      payload
    } = action;
    const response = yield call(updateHeaderData, payload);
    yield put(retrieveTripsRequestSuccess({
      payload: response.data,
      index: payload.cardId
    }));
  } catch (error) {
    yield put(retrieveTripsRequestFailure({
      error: error.message,
      index: action?.payload.cardId
    }));
  }
}
function* getTripsData(action) {
  const {
    payload
  } = action;
  try {
    const response = yield call(fetchUpcomingTripData, payload);
    yield put(getTripsDataSuccess(response?.data));
  } catch (error) {
    yield put(getTripsDataFailure(error.message));
  }
}
function* getTripsDataClaim(action) {
  const {
    payload
  } = action;
  try {
    const response = yield call(fetchUpcomingTripData, payload);
    yield put(getMyTripsDataSuccess(response?.data));
  } catch (error) {
    yield put(getMyTripDataFailure(error.message));
  }
}
export function* watchUpcomingTripData() {
  yield takeLatest(myTripsDataRequest.type, getUpcomingTripsData);
}
export function* watchAddMyTripData() {
  yield takeLatest(postAddTripPending.type, postAddTripsData);
}
export function* watchPnrData() {
  yield takeLatest(myTripsPnrRequest.type, getPnrData);
}
export function* watchCheckinData() {
  yield takeLatest(myTripsCheckinRequest.type, getCheckinData);
}
export function* watchRetrieveTripData() {
  yield takeLatest(retrieveTripsRequest.type, retrieveTripDetails);
}
export function* watchTripData() {
  yield takeLatest(tripsDataRequest.type, getTripsData);
}
export function* watchUpcomingTripDataClaim() {
  yield takeLatest(myTripsDataRequestClaim.type, getTripsDataClaim);
}